var exports = {
  "iE": "xaee3c4fa--18eb73--wrapper",
  "DD": "xaee3c4fa--18eb73--title",
  "p6": "xaee3c4fa--18eb73--date",
};

module.exports = exports;
